import AirPlaneIcon from 'assets/images/icons/airplane-svgrepo-com.svg';
import ReturningPackageIcon from 'assets/images/icons/return-box-cycle-svgrepo-com.svg';
import SecureCheckoutIcon from 'assets/images/icons/shield-check-svgrepo-com.svg';
import WarrantyIcon from 'assets/images/icons/warranty-term-svgrepo-com.svg';
import { IProductPolicyWidget } from 'types/product';

import { productDetailWidgets } from '@app/common/helpers';

export const SM_SCREEN_BREAKPOINT = 640;

export const MD_SCREEN_BREAKPOINT = 768;

export const LG_SCREEN_BREAKPOINT = 1024;

export const XL_SCREEN_BREAKPOINT = 1280;

export const XXL_SCREEN_BREAKPOINT = 1536;

export const PROD_BASE_URL = 'https://elixirmallvn.com';

export const STORAGE_AUTH_ACCESS_TOKEN = 'AuthenticationAccessToken';

export const userGender: { label: string; value: number }[] = [
  {
    label: 'labels.female',
    value: 0
  },
  {
    label: 'labels.male',
    value: 1
  }
];

export const SECOND = 1000;

export const MINUTE = SECOND * 60;

export const HOUR = MINUTE * 60;

export const DAY = HOUR * 24;

export const productDetailWidgetsWithIcon: IProductPolicyWidget[] = [
  {
    ...productDetailWidgets[0],
    icon: AirPlaneIcon
  },
  {
    ...productDetailWidgets[1],
    icon: ReturningPackageIcon
  },
  {
    ...productDetailWidgets[2],
    icon: WarrantyIcon
  },
  {
    ...productDetailWidgets[3],
    icon: SecureCheckoutIcon
  }
];
